import { businessSteps } from "../../Containers/GettingStartedPage/utils/businessSteps"
import { getOnboardingSteps } from "../../Containers/GettingStartedPage/utils/getOnboardingSteps"
import { createAccountStepPath, onboardingStepPath } from "../utils"
import { isOnboardingFinished as getIsOnboardingFinished } from "./isOnboardingFinished"

export const JOURNEY_FLOWS = {
  ONBOARDING: "onboarding",
  CREATE_BUSINESS: "create_business",
  INVITED_CREATE_BUSINESS: "invited_create_business"
}

export const mapOnboardingStepToBusinessStep = (step) => {
  if (!step) return 1

  return Math.max(step - 2, 1)
}

export const getCreateBaMaxStep = (userState) => {
  const maxCreateSteps = userState?.maxCreateSteps
  const businessAccounts = userState?.businessAccounts ?? []

  const getBASteps = (ba) => ba?.completed_steps?.split("/") ?? []

  const incomplete = businessAccounts?.find((ba) => {
    const [cur, total] = getBASteps(ba)
    return cur < total
  })

  const [_, maxStep] = getBASteps(incomplete) ?? []

  return maxStep || maxCreateSteps || 4
}

export const getJourneyState = ({ userInfo, userState, pathname }) => {
  const isInvitedUser = !!userInfo?.is_created_by_invitation
  const isOnboardingFinished = getIsOnboardingFinished(userInfo)
  const nextStep = userInfo?.next_step ?? 2
  const nextCreateAccountStep = userState?.nextCreateAccountStep

  const maxCreateSteps = isOnboardingFinished ? getCreateBaMaxStep(userState) : 6

  const isCreateBusinessFlow = pathname?.includes("/new-business") || nextCreateAccountStep !== null
  const isInvitedCreateBusinessFlow = isInvitedUser && !isOnboardingFinished && isCreateBusinessFlow

  if (isCreateBusinessFlow) {
    const invitedBusinessStep = mapOnboardingStepToBusinessStep(nextStep)
    const currentStep = isInvitedCreateBusinessFlow
      ? invitedBusinessStep
      : (nextCreateAccountStep ?? 1)

    return {
      flow: isInvitedCreateBusinessFlow
        ? JOURNEY_FLOWS.INVITED_CREATE_BUSINESS
        : JOURNEY_FLOWS.CREATE_BUSINESS,
      currentStep,
      steps: businessSteps.slice(0, maxCreateSteps),
      routeByStep: createAccountStepPath,
      isBusinessFlow: true
    }
  }

  return {
    flow: JOURNEY_FLOWS.ONBOARDING,
    currentStep: nextStep,
    steps: getOnboardingSteps({
      email: userInfo?.email,
      isEdit: true,
      isVerify: true
    }),
    routeByStep: onboardingStepPath,
    isBusinessFlow: false
  }
}
